import { Link } from "react-router-dom";

interface NavItem {
  id: string;
  icon: string;
  label: string;
}

interface AdminSidebarProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  adminName?: string;
  onSignOut?: () => void;
}

const navItems: NavItem[] = [
  { id: "overview", icon: "ri-dashboard-3-line", label: "儀表板概覽" },
  { id: "orders", icon: "ri-file-list-3-line", label: "認購訂單" },
  { id: "supply", icon: "ri-archive-drawer-line", label: "貨源商品管理" },
  { id: "users", icon: "ri-user-settings-line", label: "會員資料中心" },
  { id: "verifications", icon: "ri-shield-user-line", label: "認證審核" },
  { id: "finance", icon: "ri-bank-card-line", label: "提領審核" },
];

export default function AdminSidebar({ activeTab, onTabChange, adminName, onSignOut }: AdminSidebarProps) {
  return (
    <aside className="w-56 shrink-0 flex flex-col bg-white border-r border-navy-100 min-h-screen">
      {/* Logo */}
      <div className="px-5 py-4 border-b border-navy-100">
        <div className="flex items-center gap-2.5">
          <div className="w-8 h-8 rounded-lg bg-navy-700 flex items-center justify-center shrink-0">
            <i className="ri-shield-check-line text-white text-sm" />
          </div>
          <div>
            <p className="font-display text-sm font-bold text-navy-900">管理後台</p>
            <p className="font-body text-[10px] text-navy-400">Admin Dashboard</p>
          </div>
        </div>
      </div>

      {/* Nav */}
      <nav className="flex-1 px-2 py-3 flex flex-col gap-0.5">
        <p className="font-body text-[10px] font-semibold text-navy-400 uppercase tracking-wider px-3 mb-1.5">
          主選單
        </p>
        {navItems.map((item) => {
          const isActive = activeTab === item.id;
          return (
            <button
              key={item.id}
              onClick={() => onTabChange(item.id)}
              className={`w-full flex items-center gap-3 px-3 py-2 rounded-lg text-left cursor-pointer whitespace-nowrap ${
                isActive
                  ? "bg-navy-700 text-white"
                  : "text-navy-600 hover:bg-navy-50 hover:text-navy-800"
              }`}
            >
              <div className="w-5 h-5 flex items-center justify-center shrink-0">
                <i className={`${item.icon} text-base`} />
              </div>
              <span className="font-body text-sm font-medium">{item.label}</span>
            </button>
          );
        })}

        <div className="h-px bg-navy-100 my-2" />
        <p className="font-body text-[10px] font-semibold text-navy-400 uppercase tracking-wider px-3 mb-1.5">
          快速連結
        </p>
        <Link
          to="/dashboard"
          className="flex items-center gap-3 px-3 py-2 rounded-lg text-navy-500 hover:bg-navy-50 hover:text-navy-800"
        >
          <div className="w-5 h-5 flex items-center justify-center shrink-0">
            <i className="ri-user-line text-base" />
          </div>
          <span className="font-body text-sm">使用者中心</span>
        </Link>
        <Link
          to="/"
          className="flex items-center gap-3 px-3 py-2 rounded-lg text-navy-500 hover:bg-navy-50 hover:text-navy-800"
        >
          <div className="w-5 h-5 flex items-center justify-center shrink-0">
            <i className="ri-home-line text-base" />
          </div>
          <span className="font-body text-sm">返回首頁</span>
        </Link>
      </nav>

      {/* Admin info & sign out */}
      <div className="px-4 py-3 border-t border-navy-100">
        {adminName && (
          <div className="flex items-center gap-2 mb-2.5">
            <div className="w-7 h-7 rounded-full bg-navy-700 flex items-center justify-center shrink-0">
              <i className="ri-admin-line text-white text-xs" />
            </div>
            <div className="min-w-0">
              <p className="font-body text-xs font-medium text-navy-800 truncate">{adminName}</p>
              <p className="font-body text-[10px] text-navy-400">管理員</p>
            </div>
          </div>
        )}
        {onSignOut && (
          <button
            onClick={onSignOut}
            className="w-full flex items-center gap-2 px-3 py-2 rounded-lg text-red-500 hover:bg-red-50 cursor-pointer"
          >
            <div className="w-4 h-4 flex items-center justify-center shrink-0">
              <i className="ri-logout-box-r-line text-sm" />
            </div>
            <span className="font-body text-xs font-medium">安全登出</span>
          </button>
        )}
        <div className="flex items-center gap-2 mt-2">
          <div className="w-2 h-2 rounded-full bg-emerald-500 shrink-0" />
          <span className="font-body text-[11px] text-navy-400">系統運作正常</span>
        </div>
      </div>
    </aside>
  );
}